import { Button } from '@mui/material'
import React, { useState } from 'react'

import { ScenarioRun } from 'api'
import Text from 'components/common/Text'
import { ScenarioHaltConfirmationModal } from 'components/scenarios/detail/ScenarioActions'
import { getRunStage } from 'components/scenarios/utils'
import theme from 'theme'

const TitleContent: React.FC<{ scenario: ScenarioRun }> = ({ scenario }) => {
  return (
    <div
      css={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column'
      }}
    >
      Scenario Completed
      <Text
        as="small"
        color="medium"
        css={{
          fontSize: theme.fontSizes[1],
          marginTop: theme.space[2]
        }}
      >
        <strong>{scenario.name || 'Your scenario'}</strong> has{' '}
        {getRunStage(scenario)}
      </Text>
    </div>
  )
}

export const InputResultsButton: React.FC<{
  doFetch(): void
  scenario: ScenarioRun
  title?: string
}> = ({ doFetch, scenario, title = 'Input Results' }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const handleClick = (event) => {
    event.stopPropagation()
    setIsModalOpen(true)
  }

  // TODO migrate ScenarioHaltConfirmationModal to MUI
  return (
    <>
      <Button
        data-test-input-results
        color="info"
        size="small"
        variant="outlined"
        onClick={handleClick}
      >
        {title}
      </Button>
      <ScenarioHaltConfirmationModal
        isCompletedNotification
        isScenarioRun
        confirmButtonType="primary"
        confirmText="Save"
        doFetch={doFetch}
        haltConfirmationOpen={isModalOpen}
        hideOverlay={false}
        scenario={scenario}
        scenarioId={scenario?.scenario_id}
        selectedRun={scenario}
        setDisableButton={() => true}
        setHaltConfirmationOpen={setIsModalOpen}
        shouldCloseOnOverlayClick={false}
        showHaltButton={false}
        title={<TitleContent scenario={scenario} />}
      />
    </>
  )
}
